module.exports = __webpack_public_path__ + "static/media/Extreme-Dance-Competition-Logo.a2d7932e.png";